import {createRouter, createWebHistory} from 'vue-router'

const routes = [
    {
        path: '/invite',
        children: [
            {
                path: '/invite',
                name: 'invite',
                component: () => import('@/views/inviteFirst/inviteFirst.vue'),
                meta: {title: '邀请好友'},
            },
            {
                path: 'rule',
                name: 'rule',
                component: () => import('@/views/inviteFirst/rule.vue'),
                meta: {title: '规则说明'},
            },
            {
                path: 'incomeInvite',
                name: 'incomeInvite',
                component: () => import('@/views/inviteFirst/incomeInvite.vue'),
                meta: {title: '收益明细'},
            },
            {
                path: 'myFriend',
                name: 'myFriend',
                component: () => import('@/views/inviteFirst/myFriend.vue'),
                meta: {title: '我的好友'},
            },
            {
                path: 'invitePlacard',
                name: 'invitePlacard',
                component: () => import('@/views/inviteFirst/invitePlacard.vue'),
                meta: {title: '海报'},
            },
            {
                path: 'shareMakeUp',
                name: 'shareMakeUp',
                component: () => import('@/views/inviteFirst/shareMakeUp.vue'),
                meta: {title: '邀请好友'},
            },
        ]
    },
    {
        path: '/brand',
        name: 'brand',
        component: () => import('@/views/brand/index.vue'),
        meta: {title: '大牌点餐'}
    },
    {
        path: '/incomeDetails',
        name: 'incomeDetails',
        component: () => import('@/views/incomeDetails/index.vue'),
        meta: {title: '收支明细'}
    },

    {
        path: "/incomeDetailsNew",
        name: "incomeDetailsNew",
        component: () => import("../views/incomeDetails/entrance.vue"),
        meta: {title: '收支明细'}
    },
    {
        path: "/GlodRecode",
        name: "GlodRecode",
        component: () => import("../views/incomeDetails/GlodRecode.vue"),
        meta: {title: '金币记录'},
    },

    {
        path: "/QuestionList",
        name: "QuestionList",
        component: () => import("../views/question/questionList.vue"),
        meta: {title: '意见反馈'}
    },
    {
        path: "/QuestionListDetails",
        name: "QuestionListDetails",
        component: () => import("../views/question/questionListDetails.vue"),
        meta: {title: '意见反馈'}
    },
    {
        path: "/feedback",
        name: "feedback",
        component: () => import("../views/question/feedback.vue"),
         meta: { title: '意见反馈' }
    },
    {
        path: "/MyFeedBack",
        name: "MyFeedBack",
        component: () => import("../views/question/MyFeedBack.vue"),
         meta: { title: '意见反馈' }
    },
    {
        path: "/MyFeedBackDetails",
        name: "MyFeedBackDetails",
        component: () => import("../views/question/MyFeedBackDetails.vue"),
         meta: { title: '意见反馈' }
    },
    {
        path: "/msgCentent",
        name: "msgCentent",
        component: () => import("../views/message/message/index.vue"),
        meta: {title: '消息中心'}
    },
    {
        path: "/messageList",
        name: "messageList",
        component: () => import("../views/message/messageList/index.vue"),
        meta: {title: '消息中心'}
    },
    {
        path: "/messageDetails",
        name: "messageDetails",
        component: () => import("../views/message/messageDetails/index.vue"),
        meta: {title: '消息中心'}
    },

    {
        path: "/withdrawalRecord",
        name: "withdrawalRecord",
        component: () => import("../views/withdrawalRecord/index.vue"),
        meta: {title: '提现记录'}
    },
    {
        path: "/withdrawalDetails",
        name: "withdrawalDetails",
        component: () => import("../views/withdrawalDetails/index.vue"),
        meta: {title: '提现'}
    },
    {
        path: "/withdrawal",
        name: "withdrawal",
        component: () => import("../views/withdrawal/index.vue"),
        meta: {title: '提现'}
    },

    {
        path: '/policy',
        children: [
            {
                path: 'cloudAccount',
                name: 'cloudAccount',
                component: () => import('@/views/policy/cloudAccount.vue'),
                meta: {title: '灵活就业合作伙伴协议'},
            }
        ]
    },
    {
        path: '/credit',
        children: [
            {
                path: '/credit',
                name: 'credit',
                component: () => import('@/views/credit/credit.vue'),
                meta: {title: '信用分'},
            },{
                path: 'creditRule',
                name: 'creditRule',
                component: () => import('@/views/credit/creditRule.vue'),
                meta: {title: '信用分介绍'},
            }
        ]
    },

    {
        path: "/orderDetails",
        name: "orderDetails",
        component: () => import("../views/orderDetails/index.vue"),
        meta: {title: '订单详情'},
    },

    {
        path: "/taskDetailsRule",
        name: "taskDetailsRule",
        component: () => import("../views/taskDetailsRule/index.vue"),
        meta: {title: '活动参与规则'},
    },

    {
        path: "/toTaoBao",
        name: "toTaoBao",
        component: () => import("../views/toTaoBao/toTaoBao.vue"),
        meta: {title: '活动参与规则'},
    },
    {
        path: "/newUserCourse",
        name: "newUserCourse",
        component: () => import("../views/newUserCourse/index.vue"),
        meta: {title: '新手引导'},
    },
    {
        path: "/newUserCourse/redGroup",
        name: "newUserCourse/redGroup",
        component: () => import("../views/newUserCourse/redGroup.vue"),
        meta: {title: '赚钱秘籍'},
    },


    {
        path: "/challenge/home",
        name: "challenge/home",
        component: () => import("../views/challenge/home/index.vue"),
        meta: {title: '竹米挑战赛'},
    },
    {
        path: "/challenge/recode",
        name: "challenge/recode",
        component: () => import("../views/challenge/recode/index.vue"),
        meta: {title: '参与记录'},
    },
    {
        path: "/challenge/rule",
        name: "challenge/rule",
        component: () => import("../views/challenge/rule/index.vue"),
        meta: {title: '团长挑战赛规则'},
    },
    {
        path: "/challenge/course",
        name: "challenge/course",
        component: () => import("../views/challenge/course/index.vue"),
        meta: {title: '邀请秘籍'},
    },
    {
        path: "/challenge/inviteList",
        name: "challenge/inviteList",
        component: () => import("../views/challenge/inviteList/index.vue"),
        meta: {title: '收支明细'},
    },

    // {
    //     path: "/treasureBox/boxHome",
    //     name: "treasureBox/boxHome",
    //     component: () => import("../views/treasureBox/boxHome.vue"),
    //     meta: {title: '开宝箱赢好礼'},
    // },
    {
        path: "/treasureBox/boxHome",
        name: "treasureBox/boxHome",
        component: () => import("../views/treasureBox/boxHomeNew.vue"),
        meta: {title: '幸运抽奖'},
    },

    {
        path: "/treasureBox/reward",
        name: "treasureBox/reward",
        component: () => import("../views/treasureBox/reward.vue"),
        meta: {title: '我的奖品'},
    },
    {
        path: "/treasureBox/rule",
        name: "treasureBox/rule",
        component: () => import("../views/treasureBox/rule.vue"),
        meta: {title: '活动规则'},
    },{
        path: "/rank/rankHome",
        name: "rank/rankHome",
        component: () => import("../views/rank/rankHome.vue"),
        meta: {title: '省钱排行榜'},
    },
    {
        path: "/rebate/mtRebate",
        name: "rebate/mtRebate",
        component: () => import("../views/rebate/mtRebate.vue"),
        meta: {title: '美团返利狂欢节'},
    },
    {
        path: "/rebate/elmRebate",
        name: "rebate/elmRebate",
        component: () => import("../views/rebate/elmRebate.vue"),
        meta: {title: '饿了么返利'},
    },
    {
        path: "/rebate/tbRebate",
        name: "rebate/tbRebate",
        component: () => import("../views/rebate/tbRebate.vue"),
        meta: {title: '淘宝返利'},
    },
    {
        path: "/rebate/jdRebate",
        name: "rebate/jdRebate",
        component: () => import("../views/rebate/jdRebate.vue"),
        meta: {title: '京东返利'},
    },
    {
        path: "/rebate/RebateRecode",
        name: "rebate/RebateRecode",
        component: () => import("../views/rebate/RebateRecode.vue"),
        meta: {title: '返利记录'},
    },
    {
        path: "/rebate/rule",
        name: "rebate/rule",
        component: () => import("../views/rebate/rule.vue"),
        meta: {title: '返利秘籍'},
    },
    {
        path: "/makeMoney",
        name: "makeMoney",
        component: () => import("../views/makeMoney/index.vue"),
        meta: {title: '赚钱'},
    },
    {
        path: "/myFriends",
        name: "myFriends",
        component: () => import("../views/makeMoney/makeMyFriend.vue"),
        meta: {title: '我的好友'},
    },
    {
        path: "/makeUpRule",
        name: "makeUpRule",
        component: () => import("../views/makeMoney/makeUpRule.vue"),
        meta: {title: '快速升级秘籍'},
    },
    {
        path: "/CashbackRecordNew",
        name: "CashbackRecordNew",
        component: () => import("../views/CashbackRecordNew/index.vue"),
        meta: {title: '霸王餐返利'},
    },
    {
        path: "/air/GoldBambooRecode",
        name: "air/GoldBambooRecode",
        component: () => import("../views/air/GoldBambooRecode.vue"),
        meta: {title: '金竹记录'},
    },
    {
        path: "/air/GoldBambooReward",
        name: "air/GoldBambooReward",
        component: () => import("../views/air/GoldBambooReward.vue"),
        meta: {title: '奖励记录'},
    },
    {
        path: "/air/GoldBambooZoology",
        name: "air/GoldBambooZoology",
        component: () => import("../views/air/GoldBambooZoology.vue"),
        meta: {title: '金竹记录'},
    },
    {
        path: "/air/GoldBambooHome",
        name: "air/GoldBambooHome",
        component: () => import("../views/air/GoldBambooHome.vue"),
        meta: {title: ''},
    },
    {
        path: "/vip",
        name: "vip",
        component: () => import("../views/vip/vip.vue"),
        meta: {title: '会员中心'},
    },
    {
        path: "/vip",
        name: "vip",
        component: () => import("../views/vip/vipNew.vue"),
        meta: {title: '会员中心'},
    },
    {
        path: "/vipPerDetails",
        name: "vipPerDetails",
        component: () => import("../views/vip/vipPerDetails.vue"),
        meta: {title: '会员权益'},
    },
    {
        path: "/canteen/home",
        name: "canteen/home",
        component: () => import("../views/canteen/home.vue"),
        meta: {title: ''},
    },
    {
        path: "/canteen/paradise",
        name: "canteen/paradise",
        component: () => import("../views/canteen/paradise.vue"),
        meta: {title: ''},
    },
    {
        path: "/canteen/incomeRecode",
        name: "canteen/incomeRecode",
        component: () => import("../views/canteen/incomeRecode.vue"),
        meta: {title: '明细记录'},
    },
    {
        path: "/canteen/employeeList",
        name: "canteen/employeeList",
        component: () => import("../views/canteen/employeeList.vue"),
        meta: {title: '我的员工'},
    },
    {
        path: "/canteen/ctCourse",
        name: "canteen/ctCourse",
        component: () => import("../views/canteen/ctCourse.vue"),
        meta: {title: '教程'},
    },{
        path: "/partner",
        name: "partner",
        component: () => import("../views/partner/index.vue"),
        meta: {title: '合伙人计划'},
    },{
        path: "/partnerRule",
        name: "partnerRule",
        component: () => import("../views/partner/rule.vue"),
        meta: {title: '规则说明'},
    },{
        path: "/partnerMembers",
        name: "partnerMembers",
        component: () => import("../views/partner/partnerMembers.vue"),
        meta: {title: '我的团员'},
    },
]

const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_PUBLICPATH),
    routes
})

router.beforeEach((to, from, next) => {
    document.title = to.meta.title
    // 在这里进行权限验证、登录判断等操作
    next() // 跳转到下一个路由
})

router.afterEach(() => {
    // 跳转后的操作
})

router.beforeResolve((to, from, next) => {
    // 在导航被确认之前的操作
    next()
})

export default router
